<script setup>
import { ICONS } from "@/modules/agency-fees/constants";

const props = defineProps({
  bonusElement: {
    // bonusElement.type -> pending | progress | done
    type: Object,
    required: true,
  },
});

const getCurrentIconClass = () => {
  return ICONS[props.bonusElement.type] || ICONS.pending;
};

const getCurrentFillStyle = () => {
  if (props.bonusElement.type === "progress") {
    return {
      "--p":
        (props.bonusElement.currentProgress / props.bonusElement.progressTo) *
          100 +
        "%",
    };
  }
  if (props.bonusElement.type === "done") {
    return { "--p": "100%" };
  }
  return {};
};
</script>

<template>
  <div class="bonus-element">
    <div class="bonus-element__header">
      {{ bonusElement.headerText }}
    </div>
    <div
      :class="[
        'bonus-element__content',
        `bonus-element__content_${bonusElement.type}`,
        { 'bonus-element__content_complete': bonusElement.type !== 'pending' },
      ]"
      :style="getCurrentFillStyle()"
    >
      <span :class="['icon', getCurrentIconClass()]"></span>
      <span
        v-if="bonusElement.type === 'progress'"
        class="bonus-element__content-progress"
      >
        {{ bonusElement.currentProgress }}
      </span>
    </div>
    <div class="bonus-element__footer">
      <template v-if="bonusElement.footerText">
        {{ bonusElement.footerText }}
      </template>
      <template v-else-if="bonusElement.type === 'progress'">
        <span>
          {{ bonusElement.progressFrom }}
        </span>
        <span>
          {{ bonusElement.progressTo }}
        </span>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.bonus-element {
  display: flex;
  min-width: 32px;
  width: fit-content;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;

  &__header {
    color: var(--text-dark-primary, #212121);
    text-align: center;
    @include caption-1-bold;
    height: 17px;
  }

  &__content {
    display: flex;
    align-items: center;
    border-radius: 16px;
    border: 2px solid var(--background-light-primary, #fff);
    background: var(--background-light-third, #f3f3f3);

    &-progress {
      color: var(--text-dark-primary, #212121);
      @include text-2;
    }

    &_complete {
      background-image: linear-gradient(
          to right,
          var(--primary-color, #ffda7a) 0,
          var(--primary-color, #ffda7a) 100%
        ),
        none;
      background-repeat: no-repeat;
      background-size: var(--p, 0%) 100%;
    }

    &_progress {
      height: 32px;
      padding: 8px;
      width: 120px;
      justify-content: flex-start;
      gap: 8px;
    }

    &_pending,
    &_done {
      justify-content: center;
      height: 32px;
      width: 32px;
    }

    > .icon {
      width: 16px;
      height: 16px;
      background-color: #1e1f21;
    }
  }

  &__footer {
    color: var(--text-dark-sixth, #969696);
    text-align: center;
    width: 100%;
    @include caption-1;
    display: flex;
    justify-content: space-between;
    height: 17px;
  }
}
</style>
